import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { PaginationParams } from '../interfaces/user.interface';
import { SKIP_AUTH } from '../interceptors/auth.interceptor';
import { environment } from '../../../environments';

export interface CreateAppointmentDto {
  passportNumber: string;
  reason: {
    id: string;
    label: string;
  };
  date: string;
  startTime: string;
  endTime: string;
  notes: string;
  externalId: string;
  structure: {
    id: string;
    name: string;
  };
}


export interface Agenda {
  _id: string;
  name: string;
  tenantId: string;
  organizationId: string;
  externalId: string;
  deleted: boolean;
  type: string;
  maxReservationsPerSlot: number;
  autoValidate: boolean;
  minNoticeBeforeBooking: number;
  timezone: string;
  customFields: {
    externalId: string;
    structureId: string;
    organismId: number;
  };
  createdAt: string;
  updatedAt: string;
  __v: number;
  paymentPolicy: {
    requiresDeposit: boolean;
    deposit: {
      type: string;
      percentage: number;
      currency: string;
      amount: number;
    };
    cancellation: {
      rules: Array<{
        minMinutesBefore: number;
        refundPercent: number;
      }>;
    };
  };
}
export interface AppointmentAvailability {
  date: string;
  agendaId: string;
  dayOfWeek: number;
  startTime: string;
  endTime: string;
  startDateFull: string;
  endDateFull: string;
  isAvailable: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AppointmentService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  // Créer un rendez-vous
  createAppointment(appointmentData: CreateAppointmentDto): Observable<any> {
    return this.http.post(`${this.baseUrl}/appointments`, appointmentData, {
      headers: this.getHeaders(),
    });
  }

  // Obtenir les rendez-vous
  getAppointments(params: PaginationParams = {}): Observable<any> {
    const httpParams = this.createParams(params);
    return this.http.get(`${this.baseUrl}/appointments`, {
      headers: this.getHeaders(),
      params: httpParams,
    });
  }

  /**
   * Récupère les créneaux de disponibilité pour les rendez-vous.
   * Retourne un tableau d'objets AppointmentAvailability.
   */
  getAppointmentsAvailabilities(
    params: PaginationParams = {},
    structureId?: string,
    doctorId?: string,
    startDate?: string,
    endDate?: string
  ): Observable<{ agenda: Agenda; avaibilities: AppointmentAvailability[] }> {
    const httpParams = this.createParams({
      ...params,
      structureId,
      doctorId,
      startDate,
      endDate,
    });

    return this.http.get<{ agenda: Agenda; avaibilities: AppointmentAvailability[] }>(
      `${this.baseUrl}/appointments/avaibilities`,
      {
        headers: this.getHeaders(),
        params: httpParams,
      }
    );
  }

  // Obtenir les détails d'un rendez-vous
  getAppointmentDetails(appointmentId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/appointments/${appointmentId}`, {
      headers: this.getHeaders(),
    });
  }

  // Annuler une réservation
  cancelReservation(appointmentId: string): Observable<any> {
    return this.http.patch(
      `${this.baseUrl}/appointments/${appointmentId}/cancel`,
      {},
      { headers: this.getHeaders() }
    );
  }
  payReservation(data: any,type: string): Observable<any> {

     const headers = new HttpHeaders({
          'X-API-Key': environment.paymentToken,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        });
    
        const url = `https://api.test.bictorys.com/pay/v1/charges?payment_type=${type}`;
    
    return this.http.post(
      url,
      data,
      { 
        headers: headers,
        context: new HttpContext().set(SKIP_AUTH, true)
      }
    );
  }
}
